
  document.addEventListener("DOMContentLoaded", function () {
    // 元のボタンを取得
    const inputBtn = document.querySelector("input[name='checkout']");

    if (inputBtn) {
      // 新しい <a> タグを作成
      const newLink = document.createElement("a");
      newLink.href = "https://maratan.tokyo/cart"; // 適宜変更
      newLink.textContent = inputBtn.value; // "支払いへ進む" をそのまま使用
      newLink.className = inputBtn.className; // クラスを引き継ぐ

      // input を <a> に置き換え
      inputBtn.replaceWith(newLink);
    }
  });
